import { getHubResourceByListRoute, getHubResourceByDetailRoute, getHubResourceByCreateRoute, getHubResourceByEditRoute, } from '../hub-resource-registry.js';
import { CANONICAL_OPERATIONS_REGISTRY } from '../../operations/index.js';
function cast(value) {
    return value;
}
function castOpt(value) {
    return value === undefined ? undefined : value;
}
function resourceActionMetadata(resource, operationId) {
    const operation = CANONICAL_OPERATIONS_REGISTRY[operationId];
    const labelKey = cast(operation?.labelKey ?? operation?.name ?? operationId);
    const descriptionKey = operation?.descriptionKey
        ? cast(operation.descriptionKey)
        : labelKey;
    return {
        id: operationId,
        labelKey,
        descriptionKey,
        permission: operation
            ? cast(operation.permissionId ?? operation.permission)
            : undefined,
        module: resource.scopeKind,
        feature: cast(resource.id),
        owner: cast(resource.scopeKind).toString(),
        privacyClassification: cast(operation?.privacyClassification ?? 'INTERNAL'),
        telemetryId: cast(operation?.telemetryId ?? operationId),
    };
}
function buildNavigateAction(resource, actionId, operationId, targetRouteId, intent, group) {
    if (!operationId || !targetRouteId)
        return undefined;
    const meta = resourceActionMetadata(resource, operationId);
    return {
        id: actionId,
        schemaVersion: 1,
        module: meta.module,
        feature: meta.feature,
        operationId: cast(operationId),
        requiredPermission: meta.permission,
        privacyClassification: meta.privacyClassification,
        telemetryId: meta.telemetryId,
        accessibilityLabelKey: meta.descriptionKey,
        owner: meta.owner,
        availability: 'AVAILABLE',
        labelKey: meta.labelKey,
        kind: 'navigate',
        intent,
        idempotencyRequired: false,
        successBehavior: 'NAVIGATE_TO',
        successNavigateTo: targetRouteId,
        errorBehavior: 'SHOW_TOAST_ERROR',
        scopePolicy: resource.scopeKind,
        group,
        order: group === 'danger' ? 100 : 10,
    };
}
export function derivePageActionsFromRoute(routeId) {
    const routeIdString = String(routeId);
    const listResource = getHubResourceByListRoute(routeIdString);
    if (listResource && listResource.createOperationId && listResource.createRouteId) {
        const createAction = buildNavigateAction(listResource, `${listResource.id}.create`, listResource.createOperationId, listResource.createRouteId, 'primary', 'primary');
        return createAction ? [createAction] : undefined;
    }
    const detailResource = getHubResourceByDetailRoute(routeIdString);
    if (detailResource) {
        const actions = [];
        const editAction = buildNavigateAction(detailResource, `${detailResource.id}.edit`, detailResource.updateOperationId, detailResource.editRouteId, 'primary', 'primary');
        if (editAction)
            actions.push(editAction);
        const deleteAction = buildNavigateAction(detailResource, `${detailResource.id}.delete`, detailResource.deleteOperationId, detailResource.listRouteId, 'danger', 'danger');
        if (deleteAction) {
            deleteAction.successBehavior = 'NAVIGATE_TO';
            actions.push(deleteAction);
        }
        return actions.length > 0 ? actions : undefined;
    }
    const createResource = getHubResourceByCreateRoute(routeIdString);
    if (createResource && createResource.createOperationId) {
        return undefined;
    }
    const editResource = getHubResourceByEditRoute(routeIdString);
    if (editResource && editResource.updateOperationId) {
        return undefined;
    }
    return undefined;
}
